import React from 'react';
import ImageZoom from '../ImageZoom';

interface ImageSectionProps {
  imageUrl?: string;
}

const ImageSection: React.FC<ImageSectionProps> = ({
  imageUrl,
}) => {
  if (!imageUrl) return null;

  return (
    <div
      className="
        min-h-0
        shrink-0
        overflow-hidden

        border-b
        border-dark-700
        bg-dark-900

        px-3
        py-3
        sm:px-5
        sm:py-4
      "
    >
        <div
          className="
            w-full
            min-w-0
            max-w-[620px]
            aspect-[9/16]
            min-h-0

            mx-auto
            p-0

            flex
            items-center
            justify-center

            overflow-hidden
            rounded-xl
          "
        >
          <ImageZoom
            src={imageUrl}
            alt="Prompt"
            showResetButton
          />
        </div>
    </div>
  );
};

export default ImageSection;
